import { IMDSIconButtonProps } from "@/mds/components/buttons/icon-button/icon-button.types";
import {
  StyledButton,
  StyledIconWrapper,
} from "@/mds/components/buttons/icon-button/icon-button.styles";
import {
  MDSIconButtonSize,
  MDSIconButtonVariant,
} from "@/mds/components/buttons/icon-button/icon-button.types";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";
import { forwardRef, Ref } from "react";

export const MDSIconButton = forwardRef(
  (
    {
      variant = MDSIconButtonVariant.Default,
      size = MDSIconButtonSize.Small,
      iconKind,
      isLoading,
      isDisabled,
      ...props
    }: IMDSIconButtonProps,
    ref: Ref<HTMLButtonElement>
  ) => {
    return (
      <StyledButton
        variant={variant}
        size={size}
        {...props}
        isDisabled={isLoading || isDisabled}
        ref={ref}
        data-mds-name="icon-button"
      >
        <StyledIconWrapper className="mds-btn-icon-wrapper">
          {isLoading ? (
            <MDSIcon kind={MDSIconKind.Spinner} />
          ) : iconKind instanceof Function ? (
            iconKind()
          ) : (
            <MDSIcon kind={iconKind} />
          )}
        </StyledIconWrapper>
      </StyledButton>
    );
  }
);
